import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7ed4b5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-8 col-sm-12 mb-4" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "h1" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Trenéři:")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "kometa-team-komunkace list-unstyled" }
const _hoisted_10 = {
  key: 0,
  class: "my-2 fw-bold"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Instagram ")
const _hoisted_13 = {
  key: 1,
  class: "my-2 fw-bold"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Facebook ")
const _hoisted_16 = {
  key: 2,
  class: "my-2 fw-bold"
}
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Youtube ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "h2 w-100 text-center" }, "O týmu", -1))
const _hoisted_20 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_skater = _resolveComponent("skater")!
  const _component_icon = _resolveComponent("icon")!
  const _component_members_with_picture = _resolveComponent("members-with-picture")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.team.obrazekObsahu,
            alt: _ctx.team.jmeno,
            class: "img-fluid kometa-image-rounded"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", {
          class: "col-md-4 col-sm-6 offset-md-0 offset-sm-4 mb-4",
          style: _normalizeStyle(`color: ${_ctx.team.barva}`)
        }, [
          _createVNode(_component_skater, {
            color: _ctx.team.barva
          }, null, 8, ["color"]),
          _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.team.jmeno), 1),
          _createElementVNode("p", null, [
            _hoisted_7,
            _hoisted_8,
            _createTextVNode(_toDisplayString(_ctx.team.trener), 1)
          ]),
          _createElementVNode("ul", _hoisted_9, [
            (_ctx.team.komunikace.instagram)
              ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                  _createElementVNode("a", {
                    href: _ctx.team.komunikace.instagram,
                    style: _normalizeStyle(`color: ${_ctx.team.barva}`)
                  }, [
                    _createVNode(_component_icon, {
                      type: "fab",
                      "icon-name": "instagram"
                    }),
                    _hoisted_12
                  ], 12, _hoisted_11)
                ]))
              : _createCommentVNode("", true),
            (_ctx.team.komunikace.facebook)
              ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                  _createElementVNode("a", {
                    href: _ctx.team.komunikace.facebook,
                    style: _normalizeStyle(`color: ${_ctx.team.barva}`)
                  }, [
                    _createVNode(_component_icon, {
                      type: "fab",
                      "icon-name": "facebook"
                    }),
                    _hoisted_15
                  ], 12, _hoisted_14)
                ]))
              : _createCommentVNode("", true),
            (_ctx.team.komunikace.youtube)
              ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                  _createElementVNode("a", {
                    href: _ctx.team.komunikace.youtube,
                    style: _normalizeStyle(`color: ${_ctx.team.barva}`)
                  }, [
                    _createVNode(_component_icon, {
                      type: "fab",
                      "icon-name": "youtube"
                    }),
                    _hoisted_18
                  ], 12, _hoisted_17)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 4)
      ]),
      _hoisted_19,
      _createElementVNode("div", {
        innerHTML: _ctx.team.obsah
      }, null, 8, _hoisted_20),
      (_ctx.team.clenky)
        ? (_openBlock(), _createBlock(_component_members_with_picture, {
            key: 0,
            members: _ctx.team.clenky,
            color: _ctx.team.barva
          }, null, 8, ["members", "color"]))
        : _createCommentVNode("", true)
    ])
  ]))
}